import { format } from "date-fns";

export const formatDate = (date: string | Date, time: boolean = false) => {
    const formatStr = time ? "p '•' M/d/yy" : "M/d/yy";

    return format(date, formatStr);
};
